import React, {useState} from "react";

const TooltipButton = ({ children, tooltip }: { children: React.ReactNode; tooltip: string }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative inline-block">
      <button
        type="button"
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
      >
        {children}
      </button>
      {show && (
        <div className="absolute left-1/2 -translate-x-1/2 mt-2 px-2 py-1 bg-gray-800 text-white text-xs rounded shadow z-10 whitespace-nowrap">
          {tooltip}
        </div>
      )}
    </div>
  );
};
export default TooltipButton;